import React from 'react';
import { Paper, Typography } from '@mui/material';
import { INotificationMessageBlock } from './interfaces';

export const NotificationMessageBlock: React.FC<INotificationMessageBlock> = ({
  children,
}): JSX.Element => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: '10px',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'pre-line',
        }}
      >
        {children}
      </Typography>
    </Paper>
  );
};
